import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useExportOpportunitiesMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.ISystemJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			filterRequest,
			impersonationContext,
			includeActivity,
			boardId,
		}: {
			filterRequest: Api.IOpportunitySearchRequest;
			impersonationContext?: Api.IImpersonationContext;
			includeActivity: boolean;
			boardId: string;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `board/items/export`,
				}),
				'POST',
				{
					filter: filterRequest ?? {},
					id: boardId,
					includeActivity,
				}
			);
		},
		onError,
		onSuccess,
	});
};
